import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MealPreference } from '@demind-inc/core';

import { schedulerApi } from '../api';

type MealPreferenceUpdate = Partial<MealPreference & { note?: string }>;

interface UseUpdateMealPrefParams {
  preferenceId: string;
  preferences: MealPreferenceUpdate;
  routineId: string;
}

export const useUpdateMealPref = () => {
  const queryClient = useQueryClient();

  const updateMealPrefMutation = useMutation({
    mutationFn: async ({ preferenceId, preferences, routineId }: UseUpdateMealPrefParams) => {
      if (!preferenceId || !routineId) {
        return;
      }
      await schedulerApi.updateMealPreference(preferenceId, preferences, routineId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    updateMealPref: updateMealPrefMutation.mutateAsync,
    ...updateMealPrefMutation,
  };
};
